var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOnHoldIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.625 2.27832H12.5C12.0856 2.27832 11.6882 2.44294 11.3951 2.73597C11.1021 3.02899 10.9375 3.42642 10.9375 3.84082V16.3408C10.9375 16.7552 11.1021 17.1527 11.3951 17.4457C11.6882 17.7387 12.0856 17.9033 12.5 17.9033H15.625C16.0394 17.9033 16.4368 17.7387 16.7299 17.4457C17.0229 17.1527 17.1875 16.7552 17.1875 16.3408V3.84082C17.1875 3.42642 17.0229 3.02899 16.7299 2.73597C16.4368 2.44294 16.0394 2.27832 15.625 2.27832ZM15.3125 16.0283H12.8125V4.15332H15.3125V16.0283ZM7.5 2.27832H4.375C3.9606 2.27832 3.56317 2.44294 3.27015 2.73597C2.97712 3.02899 2.8125 3.42642 2.8125 3.84082V16.3408C2.8125 16.7552 2.97712 17.1527 3.27015 17.4457C3.56317 17.7387 3.9606 17.9033 4.375 17.9033H7.5C7.9144 17.9033 8.31183 17.7387 8.60485 17.4457C8.89788 17.1527 9.0625 16.7552 9.0625 16.3408V3.84082C9.0625 3.42642 8.89788 3.02899 8.60485 2.73597C8.31183 2.44294 7.9144 2.27832 7.5 2.27832ZM7.1875 16.0283H4.6875V4.15332H7.1875V16.0283Z",
    fill: "#ACACAC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnHoldIcon);
export default __webpack_public_path__ + "static/media/OnHoldIcon.bafc9210.svg";
export { ForwardRef as ReactComponent };